package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_03_22_Day_4() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes arrive in Tenton, which is so named because of the many pitched tents. During the night watch, the heroes notice a lot of soldiers.")
    }
}
